import { render } from "./seatMapping.vue?vue&type=template&id=19b84b2a&scoped=true"
import script from "./seatMapping.vue?vue&type=script&lang=js"
export * from "./seatMapping.vue?vue&type=script&lang=js"

import "./seatMapping.vue?vue&type=style&index=0&id=19b84b2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b84b2a"]])

export default __exports__